import { Component, OnInit } from "@angular/core";
import { UdcServiceService } from "../../Services/udc-service.service";
import { UserDefinedCodes } from "../../Model/user-defined-codes";

@Component({
  selector: "home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.css"],
})
export class HomeComponent implements OnInit {
  public canSee: Boolean;
  private canSeeList: UserDefinedCodes[] = [];

  constructor(private udcService: UdcServiceService) {}

  ngOnInit() {
    this.udcService.getKeyValues("Field_Name", "CanSeeHomeLinks").subscribe(
      (response) => {
        if (response.length > 0) {
          this.canSeeList = response;
          this.canSee = this.canSeeList.some((data) => {
            return data.parentValue == localStorage.getItem("user");
          });
        } else {
          this.canSee = false;
          this.canSeeList = null;
        }
      },
      (error) => {
        this.canSee = false;
        this.canSeeList = null;
      }
    );
  }
}
